// 定位
function getLocation() {
    return new Promise((resolve, reject) => {
       
        AMap.plugin('AMap.Geolocation', function() {
            var geolocation = new AMap.Geolocation({
                // 是否使用高精度定位，默认：true
                enableHighAccuracy: true,
                // 设置定位超时时间，默认：无穷大
                timeout: 5000
            })

            geolocation.getCurrentPosition()
            AMap.event.addListener(geolocation, 'complete', onComplete)
            AMap.event.addListener(geolocation, 'error', onError)
            function onComplete(data) {
                // data是具体的定位信息
                resolve(data)
            }

            function onError(data) {
                // 定位出错
                reject(data)
            }
        })
    })
}

export {
    getLocation
}